/**
 * @generated SignedSource<<32870af11edcd072fe74869487abf2d1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type CareType = "CAREER_COACHING" | "COACHING" | "HYBRID_CARE" | "THERAPEUTIC_STRUCTURED" | "THERAPEUTIC_UNSTRUCTURED";
export type PaymentStatusEnum = "FAILED" | "PENDING" | "REFUNDED" | "SUCCESS";
export type SessionStatusEnum = "ACTIVE" | "AWAITING_PAYMENT" | "CANCELLED" | "CANCELLED_LATE" | "COMPLETED" | "EMPLOYEE_NO_SHOW" | "NO_SHOW" | "PAYMENT_EXPIRED" | "PROFESSIONAL_NO_SHOW" | "SCHEDULED";
export type SessionTypeEnum = "DROP_IN" | "MANAGER_ONE_TO_ONE" | "TEST" | "THERAPY";
import { FragmentRefs } from "relay-runtime";
export type useSessionCard_session$data = {
  readonly __typename: "Session";
  readonly careType: CareType | null | undefined;
  readonly checkoutUrl: string | null | undefined;
  readonly employee: {
    readonly name: string;
    readonly surname: string;
  } | null | undefined;
  readonly endDate: string;
  readonly hasPendingCheckInSurvey: boolean;
  readonly id: string;
  readonly number: number;
  readonly paymentStatus: PaymentStatusEnum | null | undefined;
  readonly professional: {
    readonly clinicalProfile: {
      readonly image: string | null | undefined;
      readonly professionalTitle: string | null | undefined;
    } | null | undefined;
    readonly name: string;
    readonly surname: string;
  } | null | undefined;
  readonly startDate: string;
  readonly status: SessionStatusEnum;
  readonly therapy: {
    readonly careType: CareType | null | undefined;
  } | null | undefined;
  readonly type: SessionTypeEnum;
  readonly " $fragmentType": "useSessionCard_session";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "useSessionCard_session";
};
export type useSessionCard_session$key = {
  readonly " $data"?: useSessionCard_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"useSessionCard_session">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "careType",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "surname",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useSessionCard_session",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "number",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "checkoutUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasPendingCheckInSurvey",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startDate",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "professional",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "ClinicalProfile",
              "kind": "LinkedField",
              "name": "clinicalProfile",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "image",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "professionalTitle",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "employee",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v2/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Therapy",
          "kind": "LinkedField",
          "name": "therapy",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "paymentStatus",
          "storageKey": null
        }
      ],
      "type": "Session",
      "abstractKey": null
    }
  ],
  "type": "SessionResponse",
  "abstractKey": "__isSessionResponse"
};
})();

(node as any).hash = "403dc7b8f1e7ecc5b63ad8b1593dda9f";

export default node;
